import { render, staticRenderFns } from "./watch-statistics.vue?vue&type=template&id=073d0558&scoped=true&lang=pug&"
import script from "./watch-statistics.vue?vue&type=script&lang=ts&"
export * from "./watch-statistics.vue?vue&type=script&lang=ts&"
import style0 from "./watch-statistics.vue?vue&type=style&index=0&id=073d0558&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073d0558",
  null
  
)

export default component.exports